import {
  useDashboardExpiringDealsData,
  useDashboardInventoryData,
  useDashboardSalesData,
  useGetTodos,
  useSelectedOrg,
  useSettlementCreditDetails,
} from "@fero/hooks";
import { useContext, useMemo } from "react";
import { createBigDecimalCurrencyFormatter } from "utils/currency-utils";
import { ensure } from "utils/null-and-undefined-utils";
import { LoggedInContext } from "../../../../app/app";
import { getTimeBasedGreeting } from "../../../../utils/greeting-utils";

export const useOrganisationDashboardPageViewViewModel = () => {
  const loggedInUserContext = useContext(LoggedInContext);
  const userProfile = loggedInUserContext.loginState?.user?.profile;

  const organisation = ensure(useSelectedOrg());
  const organisationCredit = useSettlementCreditDetails({
    currency: organisation.value.currency,
    counterpartyRef: {
      kind: "organisation",
      value: organisation.id,
    },
  });
  const currencyFormatter = useMemo(
    () => createBigDecimalCurrencyFormatter(organisation.value.currency)(),
    [organisation.value.currency],
  );

  const todos = useGetTodos({
    organisationId: organisation.id,
  });

  const inventoryData = useDashboardInventoryData({
    organisationId: organisation.id,
  });

  const expiringDealsData = useDashboardExpiringDealsData({
    organisationId: organisation.id,
  });

  const salesData = useDashboardSalesData({
    organisationId: organisation.id,
  });

  const greeting = useMemo(() => {
    if (userProfile?.fullname) {
      return getTimeBasedGreeting(userProfile.fullname);
    }
    return "Dashboard";
  }, [userProfile?.fullname]);

  const salesCreditLimitData = useMemo(() => {
    if (organisationCredit.isLoading || !organisationCredit.data) {
      return null;
    }

    const creditDetails = organisationCredit.data;
    const used = Number(creditDetails.creditLimitUsed);
    const total = Number(creditDetails.creditLimit);
    const remaining = total - used;

    return {
      used,
      remaining: Math.max(0, remaining),
      total,
    };
  }, [organisationCredit.data, organisationCredit.isLoading]);

  return {
    organisationCredit,
    currencyFormatter,
    todos,
    inventoryData,
    expiringDealsData,
    salesData,
    greeting,
    salesCreditLimitData,
  };
};
